import $ from 'jquery';
import email from './account-settings-email.js';
import {
	fetchJson
} from './core/ajax-json.js';
import login from './login.js';
import notifications from './notifications.js';
import currencyFormatter from './libs/currency-formatter.js';
import {
	getLocale
} from './libs/locale.js';
import websocket from './websocket/websocket-event-esm.js';

const $accountMenu = $('.account-menu');
const $myAccountSettingsMenu = $('.my-account-settings');
const $verifiedEmailSvg = $accountMenu.find('#verifiedEmailSvg');
const $notVerifiedEmailSvg = $accountMenu.find('#notVerifiedEmailSvg');
const $emailVerifyLinkListSpinner = $accountMenu.find('#emailVerifyLinkListSpinner');
const $verifiedNumberSvg = $accountMenu.find('#verifiedNumberSvg');
const $notVerifiedNumberSvg = $accountMenu.find('#notVerifiedNumberSvg');
const $phoneVerifyLinkListSpinner = $accountMenu.find('#mobileVerifyLinkListSpinner');
const $verifyPhoneWrapper = $('.js-verify_phone-number');
const $editPhoneWrapper = $('.js-verify_phone-number');
const $editEmailWrapper = $myAccountSettingsMenu.find('.js-edit_email');
const $newPhoneCode = $editPhoneWrapper.find('#new-phone-cc');
const $newPhone = $editPhoneWrapper.find('#new-phone');
const $newEmail = $editEmailWrapper.find('#new-email');
const $verifyMobileButton = $('.js-verify-get-code');


function showVerificationSpinner($spinner, show) {
	if (show) {
		$spinner.removeClass('u-hide');
		$verifiedEmailSvg.addClass('u-hide');
		$notVerifiedEmailSvg.addClass('u-hide');
	} else {
		$spinner.addClass('u-hide');
		$verifiedEmailSvg.removeClass('u-hide');
		$notVerifiedEmailSvg.removeClass('u-hide');
	}
}

//Set Verified email on/off
function setVerificationEmail(isVerified) {

	showVerificationSpinner($emailVerifyLinkListSpinner, false);

	if (isVerified) {
		$verifiedEmailSvg.removeClass('u-hide');
		$notVerifiedEmailSvg.addClass('u-hide');
	} else {
		$verifiedEmailSvg.addClass('u-hide');
		$notVerifiedEmailSvg.removeClass('u-hide');
	}
}

//Set Verified number on/off
function setVerificationNumber(isVerified) {

	showVerificationSpinner($phoneVerifyLinkListSpinner, false);

	if (isVerified) {
		$verifiedNumberSvg.removeClass('u-hide');
		$notVerifiedNumberSvg.addClass('u-hide');
		$verifyMobileButton.attr('disabled', true).data('isVerified', true);

	} else {
		$verifiedNumberSvg.addClass('u-hide');
		$notVerifiedNumberSvg.removeClass('u-hide');
		$verifyMobileButton.attr('disabled', false).data('isVerified', false);

	}
}

function populatePlayerData(resultData) {
	$('nav > .js-menu__close .page-head__title').text(`${resultData.result.firstName} ${resultData.result.lastName}`);

	$verifyPhoneWrapper.data({
		mobileCountryCode: resultData.result.mobileCountryCode,
		mobile: resultData.result.mobile
	});

	$newPhoneCode.attr('placeholder', resultData.result.mobileCountryCode);
	$newPhoneCode.val(resultData.result.mobileCountryCode);
	$newPhone.attr('placeholder', resultData.result.mobile);
	$newPhone.val(resultData.result.mobile);

	email.setUserMail(resultData.result.email, resultData.result.unconfEmail);
	email.setMailVerificationStatus(resultData.result.playerVerificationsVO.emailStatus);
	$newEmail.attr('placeholder', resultData.result.email);
	$newEmail.val(resultData.result.email);

	setVerificationNumber(resultData.result.playerVerificationsVO.mobileStatus);
	setVerificationEmail(resultData.result.playerVerificationsVO.emailStatus);
}

function fetchPlayerInfo() {
	const url = '/player/account';
	const options = {
		method: 'GET',
		credentials: 'include',
		headers: new Headers({
			'Content-Type': 'application/json'
		})
	};

	return fetch(url, options)
		.then(response => response.json());
}

// Get Player Info
function getPlayerInfo() {
	showVerificationSpinner($emailVerifyLinkListSpinner, true);
	showVerificationSpinner($phoneVerifyLinkListSpinner, true);

	return $.ajax({
		url: '/player/account',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			populatePlayerData(resultData);
		}
		if (resultData.status === 'FAILURE') {
			console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
			showVerificationSpinner($emailVerifyLinkListSpinner, false);
			showVerificationSpinner($phoneVerifyLinkListSpinner, false);
			login.doLogout();
			notifications.showNotification(resultData.errorDescription, 'red', true);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
	});

}

//Get Player Balance
function getPlayerBalance() {
	$.ajax({
		url: '/player/balance',
		type: 'GET',
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			fetchJson('/player/currency')
				.then((response2) => {
					const formattedBalance = currencyFormatter.format(resultData.result.amount, response2.result, getLocale());
					$accountMenu.find('.user-balance .user-balance__sum--balance').html(formattedBalance);
				});
		}
		if (resultData.status === 'FAILURE') {
			console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

websocket.on('player.update', (event, message) => {
	fetchJson('/player/currency')
		.then((response) => {
			const formattedBalance = currencyFormatter.format(message.totalBalance, response.result, getLocale());
			$accountMenu.find('.user-balance .user-balance__sum--balance').html(formattedBalance);
		});
});

// Get Player Points
function getPlayerPoints() {
	$.ajax({
		url: '/player/points',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			$accountMenu.find('.user-balance .user-balance__sum--points').text(resultData.result.amount);
		}
		if (resultData.status === 'FAILURE') {
			console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

export default {
	fetchPlayerInfo,
	getPlayerInfo,
	getPlayerBalance,
	getPlayerPoints,
	setVerificationEmail,
	setVerificationNumber
};



// WEBPACK FOOTER //
// ./mobile-core/src/account-info.js